export const formatCurrency = (value: number) => {
  return new Intl.NumberFormat('es-AR', {
    style: 'currency',
    currency: 'ARS',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(value);
};

export const getTypeColors = (type: string) => {
  const typeColors: Record<string, string> = {
    'e-cheque': 'bg-blue-100 text-blue-700',
    'transferencia': 'bg-purple-100 text-purple-700',
    'fijacion': 'bg-fuchsia-100 text-fuchsia-700'
  };
  return typeColors[type] || 'bg-gray-100 text-gray-700';
};

export const getTypeLabels = (type: string) => {
  const typeLabels: Record<string, string> = {
    'e-cheque': 'E-Cheque',
    'transferencia': 'Transferencia',
    'fijacion': 'Fijación'
  };
  return typeLabels[type] || type;
};

export function validarCuit(cuit: string): boolean {
  if (!cuit) return false;
  
  // Quitar guiones y espacios
  const cleanCuit = cuit.replace(/\D/g, "");

  if (cleanCuit.length !== 11) return false;

  const multiplicadores = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];
  let suma = 0;
  for (let i = 0; i < 10; i++) {
    suma += parseInt(cleanCuit[i] || '0') * (multiplicadores[i] || 0);
  }

  const resto = suma % 11;
  let digito = 11 - resto;

  if (digito === 11) {
    digito = 0;
  } else if (digito === 10) {
    const ultimoDigito = parseInt(cleanCuit[10] || '0');
    return ultimoDigito === 9 || ultimoDigito === 4;
  }

  return digito === parseInt(cleanCuit[10] || '0');
}
